import React, { useRef, useEffect } from "react";
import { useController } from "react-hook-form";
import { GdkSocialSecurityNumber } from "@gdk/social-security-number";
import TooltipLabel from "./TooltipLabel";
import { classes } from "../../util/style-utils";
import $ from 'jquery';

export default function Ssn({ control, name = "ssn", label = "SSN", disabled = false, showTooltip = true, trackingId }) {
    const socialSecurityNumber = useRef();

    const {
        field: { onChange, onBlur, value, ref },
        fieldState: { error }
    } = useController({
        name,
        control,
        defaultValue: ""
    });

    useEffect(() => {
        socialSecurityNumber.current = new GdkSocialSecurityNumber({
            content: `#${name}-container`
        });

        socialSecurityNumber.current.setSocialSecurityNumber(value);

        $(`#${name}-container input[type=tel]`).on("change", function () {
            onChange(socialSecurityNumber.current.getSocialSecurityNumber());
        });

        $(`#${name}-container input[type=tel]`).on("blur", onBlur);
    }, [name]);

    return (
        <div data-onboarding-control-id={trackingId} className={classes("form-field", error && "form-field--error")} id={`${name}-container`}>
            <div className={classes("social-security-number-wrapper form-field", error && "form-field--error")}>
                {showTooltip ? (
                    <TooltipLabel
                        htmlFor={`${name}-input-field`}
                        label={label}
                        content={
                            <>
                                At GEICO, we understand the importance of your privacy and security. The information you{" "}
                                provide will be kept confidential and secure. It will not be sold or redistributed. To{" "}
                                learn more about how we protect your personal information, please review our privacy{" "}
                                &amp; security policy:{" "}
                                <a data-onboarding-link-id="gdk:Ssn:PrivacyPolicy" href="https://media.geico.com/legal/privacy_policy.htm" target="_blank" rel="noopener noreferrer" className="">
                                    Privacy Policy
                                </a>
                            </>
                        }
                    />
                ) : (
                        <label htmlFor={`${name}-input-field`} className="text">{label}</label>
                )}
                <input
                    id={`${name}-input-field`}
                    type="tel"
                    className="social-security-number"
                    autoComplete="off"
                    spellCheck="false"
                    placeholder="___-__-____"
                    ref={ref}
                    disabled={disabled}
                />
                <input
                    type="password"
                    id={`${name}-input-value`}
                    name={`${name}-input-value`}
                    className="secureInput"
                    maxLength="11"
                    autoComplete="off"
                    spellCheck="false"
                    readOnly
                />
                <span data-onboarding-button-id="Ssn:ToggleVisibility" className="social-security-show-hide">
                    <span className="icon-hide" aria-label="Hide"></span>
                </span>
                {error && (
                    <span className="form-message">
                        {error.message}
                    </span>
                )}
            </div>
        </div>
    );
}